import { Button, Divider, Dropdown, Menu, Switch, List, Tag } from 'antd'
import React, { useState, useEffect, useContext } from 'react'
import Avatar from '../../avatar/avatar';
import { appContext } from '../../../AppContext';
import { MoreOutlined } from '@ant-design/icons';
import AddTodoModal from './modals/AddTodoModal';
import UpdateTodoModal from './modals/UpdateTodoModal';
import CommentDate from '../../timline/comments/comment-date';

export default function TodoList({
    data, 
    refresh,
    characterId,
    somethingChanged
}) { 

    const [listSource, setListSource] = useState([]);
    const [appState] = useContext(appContext);
    const [showDone, setShowDone] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [selectedTodo, setSelectedTodo] = useState({})

    const actionsDropdownComments = (
        <Menu onClick={handleActions}>
           <Menu.Item key="add">
            {`Add`}
          </Menu.Item>
          <Menu.Item key="changeShowDone">
            {`Show done todo's `}
            <Switch 
              checked={showDone} 
            />
          </Menu.Item>
        </Menu>
      );

      function handleActions({ key }) {
        switch (key) {
          case 'changeShowDone':
            setShowDone(!showDone) 
            break;
          case 'add':
            setShowAddModal(true)
            break;
          default:
            break;
        }
      }

    function onUpdateClick(todo) {
        setSelectedTodo(todo);
        setShowUpdateModal(true);

    }

    useEffect(() => {
        setListSource(data?.filter(_ => showDone ? _ : _.isDone === false).map(_ => {
            return (
                    <List.Item>
                        <List.Item.Meta
                            avatar={<Avatar name={_.larper.name} />}
                            title={ <>
                                <Tag color={_.isDone ? 'success' : 'warning'}>{_.isDone ? 'Done' : 'Todo'}</Tag>
                                <CommentDate event={_} /> 
                                {' '} 
                                <Button 
                                    size='small' 
                                    onClick={() => onUpdateClick(_)}
                                    disabled={somethingChanged}
                                >
                                    Update
                                </Button>
                            </>}
                        />
                        {`${_.description}`}            

                    </List.Item>
            )
            }));
      }, // eslint-disable-next-line
      [data, somethingChanged, showDone])

    if(!appState.isSlOfStory) {
        return null
    }

    return (
        <>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 12,
            }}>
                <Divider orientation="left">Todo's</Divider>
                <Dropdown overlay={actionsDropdownComments}>
                    <Button icon={<MoreOutlined />} size="small" />
                </Dropdown>
            </div>
            <List
                itemLayout="horizontal"
                dataSource={listSource}
                renderItem={item =>
                item
                }
            /> 

            {showAddModal && <AddTodoModal 
                setIsModalVisible={setShowAddModal}
                isModalVisible={showAddModal}
                characterId={characterId}
                refresh={refresh}
            />}

            {showUpdateModal && <UpdateTodoModal 
                setIsModalVisible={setShowUpdateModal}
                isModalVisible={showUpdateModal}
                record={selectedTodo}
                refresh={refresh}
            />}
        </>
    )
}